<script setup>
import Section from "../internal/Section.vue";
import EditableField from "../fields/EditableField.vue";
import ReadonlyField from "../fields/ReadonlyField.vue";
import { Separator } from "@/shared/ui/separator";

defineProps({
  data: { type: Object, required: true },
  editMode: { type: Boolean, default: false },
  isOwn: { type: Boolean, default: false },
});

const emit = defineEmits(["update"]);
function setField(key, value) {
  emit("update", key, value);
}
</script>

<template>
  <Section
    icon="sli-home"
    :title="$t('Домашний адрес')"
    :sub="$t('Регион, населённый пункт, контакты')"
  >
    <div
      class="grid grid-cols-3 gap-x-5 gap-y-3.5 max-md:grid-cols-2 max-sm:grid-cols-1"
    >
      <ReadonlyField
        :label="$t('Область')"
        :value="data.residential_address?.region || data.home_region"
      />
      <ReadonlyField
        :label="$t('Район')"
        :value="data.residential_address?.district || data.home_district"
      />
      <ReadonlyField
        :label="$t('Населённый пункт')"
        :value="data.residential_address?.city || data.home_city"
      />
      <ReadonlyField
        :label="$t('Улица')"
        :value="data.residential_address?.street || data.home_street"
      />
      <ReadonlyField
        :label="$t('Номер дома')"
        :value="data.residential_address?.house || data.home_house"
      />
      <ReadonlyField
        :label="$t('Квартира / офис')"
        :value="data.residential_address?.apartment || data.home_apartment"
      />
      <ReadonlyField :label="$t('Домашний телефон')" :value="data.home_phone" />
      <ReadonlyField :label="$t('Электронная почта')" :value="data.email" />
      <EditableField
        v-if="editMode"
        :label="$t('Режим работы')"
        :model-value="data.work_schedule"
        @update:model-value="setField('work_schedule', $event)"
      />
      <ReadonlyField
        v-else
        :label="$t('Режим работы')"
        :value="data.work_schedule"
      />
    </div>
    <p class="text-[12px] text-muted-foreground mt-3">
      {{ $t("Изменить адрес можно в справочнике адресов.") }}
    </p>
  </Section>

  <Section
    icon="sli-case"
    :title="$t('Адрес совершения нотариальных действий')"
    :sub="$t('Расположение офиса и страхование')"
  >
    <div
      class="grid grid-cols-4 gap-x-5 gap-y-3.5 max-md:grid-cols-2 max-sm:grid-cols-1"
    >
      <ReadonlyField
        :label="$t('Район')"
        :value="data.office_address?.district || data.office_district"
      />
      <ReadonlyField
        :label="$t('Улица')"
        :value="data.office_address?.street || data.office_street"
      />
      <ReadonlyField
        :label="$t('Номер дома')"
        :value="data.office_address?.house || data.office_house"
      />
      <ReadonlyField
        :label="$t('Квартира / офис')"
        :value="data.office_address?.apartment || data.office_apartment"
      />
    </div>

    <Separator class="my-4" />

    <div class="grid grid-cols-2 gap-x-5 gap-y-3.5 max-sm:grid-cols-1">
      <template v-if="editMode">
        <EditableField
          :label="$t('Страховая компания')"
          :model-value="data.insurance_company_name"
          @update:model-value="setField('insurance_company_name', $event)"
        />
        <EditableField
          :label="$t('Окончание договора ГПО')"
          type="date"
          :model-value="data.insurance_contract_end_date"
          @update:model-value="setField('insurance_contract_end_date', $event)"
        />
      </template>
      <template v-else>
        <ReadonlyField
          :label="$t('Страховая компания')"
          :value="data.insurance_company_name"
        />
        <ReadonlyField
          :label="$t('Окончание договора ГПО')"
          :value="data.insurance_contract_end_date"
          type="date"
        />
      </template>
    </div>
  </Section>
</template>
